import Vue from 'vue';
import Router from 'vue-router';
import AuthService from '@/service/AuthService';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'dashboard',
            component: () => import('./pages/PortfolioPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/portfolio',
            name: 'portfolioPlayersList',
            component: () => import('./pages/PortfolioPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/kpis',
            name: 'KPIs',
            component: () => import('./pages/KPIsPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/portfolioCoaching',
            name: 'coachngStaffList',
            component: () => import('./pages/PortfolioCoachingPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/home',
            name: 'home',
            component: () => import('./pages/authentication/Home'),
            meta: {
                publicLayout: true,
                publicAccess: true,
            },
        },
        {
            path: '/homeClub',
            name: 'homeClub',
            component: () => import('./pages/authentication/HomeClub'),
            meta: {
                publicLayout: true,
                publicAccess: true,
            },
        },
        {
            path: '/homePlayer',
            name: 'homePlayer',
            component: () => import('./pages/authentication/HomePlayer'),
            meta: {
                publicLayout: true,
                publicAccess: true,
            },
        },
        {
            path: '/homeAgent',
            name: 'homeAgent',
            component: () => import('./pages/authentication/HomeAgent'),
            meta: {
                publicLayout: true,
                publicAccess: true,
            },
        },
        {
            path: '/about',
            name: 'about',
            component: () => import('./pages/authentication/AboutUs'),
            meta: {
                publicLayout: true,
                publicAccess: true,
            },
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./pages/authentication/Login'),
            meta: {
                publicLayout: true,
                publicAccess: true,
            },
        },
        {
            path: '/register',
            name: 'register',
            component: () => import('./pages/authentication/Register'),
            meta: {
                publicLayout: true,
                publicAccess: true,
            },
        },
        {
            path: '/recovery',
            name: 'recovery',
            component: () => import('./pages/authentication/Recovery'),
            meta: {
                publicLayout: true,
                publicAccess: true,
            },
        },
        {
            path: '/resetpwd',
            name: 'resetpwd',
            component: () => import('./pages/authentication/Reset'),
            meta: {
                publicLayout: true,
                publicAccess: true,
            },
        },
        {
            path: '/confirm',
            name: 'confirm',
            component: () => import('./pages/authentication/Confirm'),
            meta: {
                publicLayout: true,
                publicAccess: true,
            },
        },
        {
            path: '/playerReport/:playerId/:playerName',
            name: 'playerReport',
            component: () => import('./components/player/PlayerReport'),
            meta: {
                publicLayoutWithLogo: true,
                publicAccess: true,
            },
        },
        {
            path: '/account',
            name: 'account',
            component: () => import('./pages/AccountPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/portfolio',
            name: 'portfolio',
            component: () => import('./pages/PortfolioPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/contract',
            name: 'contract',
            component: () => import('./pages/ContractPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/offer',
            name: 'offer',
            component: () => import('./pages/OfferPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/offers',
            name: 'offers',
            component: () => import('./pages/OffersPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/offerReport',
            name: 'offerReport',
            component: () => import('./components/offer/OfferReport'),
            meta: {
                publicLayoutWithLogo: true,
                publicAccess: true,
            },
        },
        {
            path: '/negotiation',
            name: 'negotiation',
            component: () => import('./pages/NegotiationPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/negotiations',
            name: 'negotiations',
            component: () => import('./pages/NegotiationsPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/negotiationsReport',
            name: 'negotiationsReport',
            component: () => import('./pages/NegotiationsReportPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/teams',
            name: 'teams',
            component: () => import('./pages/TeamsPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/teamContacts',
            name: 'teamContacts',
            component: () => import('./pages/TeamContacts.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/negotiationReport',
            name: 'negotiationReport',
            component: () => import('./components/negotiation/NegotiationReport'),
            meta: {
                publicLayoutWithLogo: true,
                publicAccess: true,
            },
        },
        {
            path: '/request',
            name: 'request',
            component: () => import('./pages/RequestPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/requests',
            name: 'requests',
            component: () => import('./pages/RequestsPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/requestsCandidates',
            name: 'requestsCandidates',
            component: () => import('./pages/RequestsCandidates.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/requestReport',
            name: 'requestReport',
            component: () => import('./components/request/RequestReport'),
            meta: {
                publicLayoutWithLogo: true,
                publicAccess: true,
            },
        },
        {
            path: '/exactMatch',
            name: 'exactMatch',
            component: () => import('./pages/ExactMatchesPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/potentialMatch',
            name: 'potentialMatch',
            component: () => import('./pages/PotentialMatchesPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/partialMatch',
            name: 'partialMatch',
            component: () => import('./pages/PartialMatchesPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/invoicesPlayers',
            name: 'invoicesPlayers',
            component: () => import('./pages/InvoicesPlayersPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/invoicesTeams',
            name: 'invoicesTeams',
            component: () => import('./pages/InvoicesTeamsPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/players',
            name: 'players',
            component: () => import('./components/negotiation/NegotiationRoom.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/procura',
            name: 'procura',
            component: () => import('./pages/DashboardPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/procuraPayment',
            name: 'procuraPayment',
            component: () => import('./pages/DashboardPaymentPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/playersList',
            name: 'playersList',
            component: () => import('./pages/PlayersListPage.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
        },
        {
            path: '/negotiationRoom',
            component: () => import('./components/whatchat/Messages.vue'),
            meta: {
                publicLayout: false,
                publicAccess: false,
            },
            children: [
                {
                    path: '$:id$',
                    name: 'conversation',
                    component: () => import('./components/whatchat/Conversation.vue'),
                    meta: {
                        publicLayout: false,
                        publicAccess: false,
                    },
                },
                {
                    path: '/',
                    name: 'whatchatWelcome',
                    component: () => import('./components/whatchat/Welcome.vue'),
                    meta: {
                        publicLayout: false,
                        publicAccess: false,
                    },
                },
            ]
        },
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
});

router.beforeEach((to, from, next) => {
    const authRequired = !to.matched.some(record => record.meta.publicAccess);
    const loggedIn = new AuthService().getUserId();

    if (authRequired && !loggedIn) {
        return next('/home');
    }

    next();
});

export default router;